import { Http, RequestOptions, Headers } from '@angular/http';
import { Component } from '@angular/core';
import { NavController, LoadingController, PopoverController, NavParams, ModalController, ToastController, AlertController, MenuController, App } from 'ionic-angular';
import firebase from 'firebase/app';
import { AngularFirestore } from 'angularfire2/firestore';
import { ViewContactPage } from '../view-contact/view-contact';
// import { LoadingProvider } from '../../providers/loading/loading';
// import { EditPopoverPage } from '../edit-popover/edit-popover';
// import { ChangeAssignedBrokerPage } from '../change-assigned-broker/change-assigned-broker';
// import { AttachmentRequestsPage } from '../attachment-requests/attachment-requests';
// import { StepformPage } from '../stepform/stepform';
// import { ChangeLogProfilePage } from '../change-log-profile/change-log-profile';
// import { TentativeRealEstateAssetPage } from '../tentative-real-estate-asset/tentative-real-estate-asset';
// import { ChangeContactTypePopupPage } from '../change-contact-type-popup/change-contact-type-popup';
// import { AngularFireAuth } from 'angularfire2/auth';
// import { HomeService } from '../../app/services/home-service';

@Component({
  selector: 'page-own-user-list',
  templateUrl: 'own-user-list.html',
})
export class OwnUserListPage {
  public email: any;
  public uid: any;
  public loading: any;
  public SDF_form_document_id: any;
  public firstname: any;
  public lastname: any;
  public data: any;
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    public loadingCtrl: LoadingController
  ) {
    let thiss = this;
    thiss.email = window.localStorage.getItem("email");
    thiss.uid = window.localStorage.getItem("uid");
    thiss.SDF_form_document_id = window.localStorage.getItem("SDF_form_document_id");
    console.log(thiss.SDF_form_document_id);
    thiss.data = [];
    let docRef = firebase.firestore().collection("users").doc(thiss.uid);
    docRef.get().then(function(doc) {
      console.log('test')
      if (doc.exists) {
        console.log('test11')
        //thiss.presentLoadingText();
        let user_data = doc.data();
        thiss.firstname = user_data.firstname;
        thiss.lastname = user_data.lastname;
        console.log('thiss.SDF_form_document_id', thiss.SDF_form_document_id);
        firebase.firestore().collection("users_data").where('SDF_form_document_id', '==', thiss.SDF_form_document_id).where('deleted', '==', 0).get()
        .then(function(querySnapshot2) {
          querySnapshot2.forEach(function(doc1) {
            console.log(doc1.data());
            //let user_data = doc.data();
            thiss.data.push(doc1.data());
          })
        })

      }
    })
    console.log('thiss.data', thiss.data)
  }

  presentLoadingText(){
    this.loading = this.loadingCtrl.create({
      content: 'Loading Please Wait...'
    });

    this.loading.present();
  }
  viewContact(event, contact_uid, SDF_form_document_id){
    this.navCtrl.push(ViewContactPage,{
      contact_uid:contact_uid,
      SDF_form_document_id:SDF_form_document_id
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad OwnUserListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/own-user-list/own-user-list.ts